import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';
import {
  Adresse,
  AdresseService,
  DplusService,
  LogService,
  Mandant,
  MandantService,
  Sendungsstatus,
  SendungsstatusService,
} from '../../api';

export const getHauptmandanten =
  (searchString: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new MandantService().getHauptmandanten(searchString).then(response => {
      dispatch({
        type: ActionTypes.GET_HAUPTMANDANTEN,
        payload: response.data,
      });

      dispatch({
        type: ActionTypes.LOADING,
        payload: false,
      });
    });
  };

export const getUntermandanten =
  (hm_id: number, searchString: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new MandantService()
      .getUntermandanten(hm_id, searchString)
      .then(response => {
        dispatch({
          type: ActionTypes.GET_CURRENTUNTERMANDANTEN,
          payload: response.data,
        });

        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };
export const getFreieMandanten =
  (searchString: string) => async (dispatch: Dispatch<ReduxAction>) => {
    //todo if (searchString.length < 2) return; // weil bei Bexity ca. 9000 Mandanten verwaltet werden
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new MandantService().getFreieMandanten(searchString).then(response => {
      dispatch({
        type: ActionTypes.GET_FREIEMANDANTEN,
        payload: response.data,
      });

      dispatch({
        type: ActionTypes.LOADING,
        payload: false,
      });
    });
  };
export const getAllMandanten =
  (searchString: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new MandantService().getAllMandanten(searchString).then(response => {
      dispatch({
        type: ActionTypes.ADRIMPORTMANDANT,
        payload: response.data,
      });

      dispatch({
        type: ActionTypes.LOADING,
        payload: false,
      });
    });
  };
export const updateMandant =
  (mandantId: number, mandant: Mandant, isHauptmandant: boolean) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new MandantService().updateMandant(mandantId, mandant).then(response => {
      const mandant = response.data;
      dispatch({
        type: isHauptmandant
          ? ActionTypes.UPDATE_MANDANT
          : ActionTypes.UPDATE_UNTERMANDANT,
        payload: mandant,
      });
    });
  };

export const getAnzeigeStati =
  (searchString: string) => async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService().getAnzeigestati(searchString).then(response => {
      dispatch({
        type: ActionTypes.GET_ANZEIGESTATI,
        payload: response.data,
      });
    });
  };
export const getSendungsStati =
  (a_id: number, searchString: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService()
      .getSendungsstatiByAnzeigestati(a_id, searchString)
      .then(response => {
        dispatch({
          type: ActionTypes.GET_CURRENTSENDUNGSSTATI,
          payload: response.data,
        });
      });
  };
export const getFreieSendungsStati =
  (searchString: string) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new SendungsstatusService()
      .getFreieSendungsstati(searchString)
      .then(response => {
        dispatch({
          type: ActionTypes.GET_FREIESENDUNGSSTATI,
          payload: response.data,
        });
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const createAnzeigeStatus =
  (anzeigeStatus: Sendungsstatus) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService().createStatus(anzeigeStatus).then(response => {
      new SendungsstatusService().getAnzeigestati('').then(response => {
        dispatch({
          type: ActionTypes.GET_ANZEIGESTATI,
          payload: response.data,
        });
      });
      new SendungsstatusService()
        .getDefaultstatuskette()
        .then((result: any) => {
          dispatch({
            type: ActionTypes.GET_DEFAULTSTATUSKETTE,
            payload: result.data,
          });
        });
    });
  };

export const deleteAnzeigeStatus =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService().deleteStatus(id).then(response => {
      new SendungsstatusService().getAnzeigestati('').then(response => {
        dispatch({
          type: ActionTypes.GET_ANZEIGESTATI,
          payload: response.data,
        });
      });
      new SendungsstatusService()
        .getDefaultstatuskette()
        .then((result: any) => {
          dispatch({
            type: ActionTypes.GET_DEFAULTSTATUSKETTE,
            payload: result.data,
          });
        });
    });
  };

/**
 * aktualisiert eine  Sendungsstatus
 * @param status der zu aktualisierende Status
 * @param anzeigestatus handelt es sich um einen Anzeigestatus @see Anzeigestatus.tsx
 * @param edit wird ein Status editiert oder zugeordnet
 *
 */
export const updateSendungsStatus =
  (status: Sendungsstatus, anzeigestatus: boolean, edit: boolean) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService().updateStatus(status).then(response => {
      new SendungsstatusService().getAnzeigestati('').then(response => {
        dispatch({
          type: ActionTypes.GET_ANZEIGESTATI,
          payload: response.data,
        });
      });
      new SendungsstatusService()
        .getDefaultstatuskette()
        .then((result: any) => {
          dispatch({
            type: ActionTypes.GET_DEFAULTSTATUSKETTE,
            payload: result.data,
          });
        });
      dispatch({
        type: ActionTypes.UPDATE_SENDUNGSSTATUS,
      });
    });
  };

export const setDefaultstatuskette =
  (statuskette: Sendungsstatus[]) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService().setStatuskette(statuskette).then(response => {
      dispatch({
        type: ActionTypes.GET_ANZEIGESTATI,
        payload: response.data,
      });
    });
  };

export const importAdressen =
  (adressen: Adresse[], mandant_id: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new AdresseService()
      .importAdressen(mandant_id, adressen)
      .then(response => {
        dispatch({
          type: ActionTypes.IMPORT_ADRESSEN,
          payload: response.data,
        });
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
        setNotification(
          'Die Adressen wurden erfolgreich importiert.',
          [],
          INFO,
          10000
        );
      })
      .catch(err => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const getServerLog = () => async (dispatch: Dispatch<ReduxAction>) => {
  new LogService().getLog(1000).then((result: any) => {
    dispatch({
      type: ActionTypes.SERVERLOG,
      payload: result.data,
    });
  });
};

export const getSessionCount =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new LogService().getSessionCount().then((result: any) => {
      dispatch({
        type: ActionTypes.SESSIONCOUNT,
        payload: result.data,
      });
    });
  };

export const updateIndex =
  (typ: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    new DplusService().updateData(typ).then(response => {
      dispatch({
        type: ActionTypes.UPDATE_INDEX,
      });

      dispatch({
        type: ActionTypes.LOADING,
        payload: false,
      });
      setNotification(
        'Der Index ' + typ + ' wurde erfolgreich aktualisiert.',
        [],
        INFO,
        5000
      );
    });
  };
